// Когда остаток последний раз приходил из 1С — и кнопка попросить свежий.
//
// Остаток теперь живёт от обмена до обмена. Раньше у нас был собственный счёт:
// цех выпустил лист — число выросло сразу. Теперь оно вырастет тогда, когда 1С
// проведёт отчёт производства и пришлёт следующий снимок.
//
// Значит, встанет обмен — экран будет показывать вчерашнее число и молчать об
// этом. Молчащий экран с неверным остатком хуже пустого: по нему принимают
// заказы и обещают то, чего нет. Поэтому строка стоит там, где на остаток
// смотрят: у склада и у менеджера.
//
// Пока всё хорошо, строка серая и незаметная — это не сообщение, а фон.
// Становится жёлтой она только тогда, когда есть о чём сказать.
import React, { useState, useEffect, useCallback } from 'react';
import { integrationAPI } from '../api';
import toast from 'react-hot-toast';

export default function StockFreshness({ style = {} }) {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    integrationAPI.stockFreshness().then(r => setSt(r.data)).catch(() => setSt(null));
  }, []);

  useEffect(() => {
    load();
    // Раз в минуту: чаще незачем, снимок и так приходит раз в пять.
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const refresh = async () => {
    setBusy(true);
    try {
      await integrationAPI.stockRefresh();
      toast.success('1С собирает снимок — обычно несколько секунд');
      // Снимок приедет отдельным запросом; подождём и перечитаем.
      setTimeout(load, 8000);
    } catch (e) {
      toast.error(e.response?.data?.error || 'Не удалось попросить 1С');
    } finally { setBusy(false); }
  };

  if (!st) return null;

  const bad = st.stale || !st.known;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      fontSize: 12.5, lineHeight: 1.5,
      color: bad ? '#f59e0b' : 'var(--dim)',
      background: bad ? '#f59e0b12' : 'transparent',
      border: bad ? '1px solid #f59e0b30' : '1px solid transparent',
      borderRadius: 8, padding: bad ? '7px 12px' : '2px 0',
      ...style,
    }}>
      <span>{bad ? '⚠ ' : ''}{st.text}</span>
      <button onClick={refresh} disabled={busy}
        style={{
          background: 'none', border: 'none', padding: 0,
          color: bad ? '#f59e0b' : 'var(--muted)', fontSize: 12.5,
          fontWeight: 700, cursor: busy ? 'default' : 'pointer',
          textDecoration: 'underline', fontFamily: 'inherit',
        }}>
        {busy ? 'Прошу…' : 'Обновить остаток'}
      </button>
    </div>
  );
}
